import React, { useState, useEffect, useRef  } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Card } from 'primereact/card';
import { Messages } from 'primereact/messages';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useAuth } from '../contexts/AuthContext.js';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import Container from 'react-bootstrap/Container';
import { Toast } from 'primereact/toast';
import { ScrollTop } from 'primereact/scrolltop';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressBar } from 'primereact/progressbar';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';
import '../config.js'

const Projects = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { locationName, locationId } = useParams();
  const [projects, setProjects] = useState([]);
  const [projectsShow, setProjectsShow] = useState([]);
  const [editProjectVisible, setEditProjectVisible] = useState(false);
  const [editProjectDraft, setEditProjectDraft] = useState(null);
  const [editProjectSaving, setEditProjectSaving] = useState(false);
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState();
  const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    orderStatus: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    lMS: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
    appProvider: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
    installer: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
    customer: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
    locations: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const msgs = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const [notesLogVisible, setNotesLogVisible] = useState(false);
  const [notesLog, setNotesLog] = useState([]);
  const [newProject, setNewProject] = useState(false);
  const [archivedProject, setArchivedProject] = useState(false);
  const [holdedProject, setHoldedProject] = useState(false);
  const editOrderDetailsmsg = useRef(null);
  const [fullOrderDetails, setFullOrderDetails] = useState([]);
    const [orderDetailsFilters, setOrderDetailsFilters] = useState({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      locationName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      gateName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      clientName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      scanType: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      size: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      colour: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    });
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [loadingOrderDetails, setLoadingOrderDetails] = useState(false);
  const [orderDetailsVisible, setOrderDetailsVisible] = useState(false);
  const [orderDetailsFilterValue, setOrderDetailsFilterValue] = useState('');
  // const [poNumber, setPoNumber] = useState('');
  // const [poValue, setPoValue] = useState('');
  // const [contactName, setContactName] = useState('');
  // const [deliveryAddress, setDeliveryAddress] = useState('');
  // const [sendUpdaterTile, setSendUpdaterTile] = useState(false);

  const toastBC = useRef(null);
  // const [createLoading, setCreateLoading] = useState(false);
  const myInterval = useRef(null);

  const op = useRef(null);
  const dt = useRef(null);

  const getTableScrollTop = () => {
    try {
      if (!dt.current || typeof dt.current.getElement !== 'function') return 0;
      const el = dt.current.getElement();
      if (!el || typeof el.querySelector !== 'function') return 0;
      const wrapper = el.querySelector('.p-datatable-wrapper');
      return wrapper && typeof wrapper.scrollTop === 'number' ? wrapper.scrollTop : 0;
    } catch {
      return 0;
    }
  };

  const restoreTableScrollTop = (scrollTop) => {
    try {
      if (!dt.current || typeof dt.current.getElement !== 'function') return;
      const el = dt.current.getElement();
      if (!el || typeof el.querySelector !== 'function') return;
      const wrapper = el.querySelector('.p-datatable-wrapper');
      if (!wrapper) return;
      requestAnimationFrame(() => {
        wrapper.scrollTop = scrollTop;
      });
    } catch {
      // ignore
    }
  };


  useEffect(() => {
    const fetchProjects = async () => {
      await getProjects();
      // updateProjectsEvery30Seconds();
    };

    fetchProjects();

    let _filters = JSON.parse(localStorage.getItem('projectsFilters'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters.global.value);
    }

    // Set up interval for updating projects every 10 seconds
    myInterval.current = setInterval(() => {
      updateProjectsEvery30Seconds();
    }, 10000);

    // Cleanup function to clear interval when component unmounts
    return () => {
      if (myInterval.current) {
        clearInterval(myInterval.current);
      }
    };
  }, [locationId, locationName]);

  useEffect(() => {

    // updateAccessPoint();
  }, []);



  const updateProjectsEvery30Seconds = () => {
    const token = localStorage.getItem('token');
      axios.get(global.config.url + `/projects/New`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setProjects(response.data);
        const ap = [...response.data];
        setProjectsShow(ap);
      }).catch((error) => {
        if (handleAccessError(error)) {
          if (myInterval.current) {
            clearInterval(myInterval.current);
          }
          setLoading(false);
        }
      });
  };

  const getProjects = async (type = "New") => {
    try {
      if(type !== "New"){
        if (myInterval.current) {
          clearInterval(myInterval.current);
        }
      }
      if(type === "Refresh"){
        type = "New";
        if(myInterval.current){
          myInterval.current = setInterval(() => {
            updateProjectsEvery30Seconds();
          }, 10000);
        }
      }

      setLoading(true);
      clearAccessIssue();
      setProjects([]);
      const token = localStorage.getItem('token');
      let header = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      
      // console.log("get replacement tiles " + locationName + " " + locationId);
      const response = await axios.get(global.config.url + `/projects/${type}`, header);
      if(response.status !== 200){
        setLoading(false);
        msgs.current.show({ severity: 'error', summary: '', detail: 'Error fetching projects' });
        return;
      }
        setProjects(response.data);
        
        const ap = [...response.data];
        // setAccessPointsShow(ap.sort((a, b) => (a.tile < b.tile) ? 1 : -1));
        setProjectsShow(ap);
        console.log(response.data);
        setLoading(false);
    } catch (error) {
      if (handleAccessError(error)) {
          setLoading(false);
          return;
        } else if (error.response && error.response.status === 500) {
          msgs.current.show({ severity: 'error', summary: '', detail: 'Internal server error occurred.' });
        } else {
          console.error('Error fetching access points:', error);
          setLoading(false);
          msgs.current.show({ severity: 'error', summary: '', detail: error.response ? error.response.data : 'Error fetching projects' });
        }
      }
  };

  const getNotesLog = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a project to see its notes log.'});
    }
    else
    {
      try{
        setLoading(true);
        const token = localStorage.getItem('token');
        var axiosConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        };
        const response = await axios.get(global.config.url + `/projects/notesLog/` + rowSelectionModel.id, axiosConfig);
        console.log(response);
        if(response.status === 200){
          setNotesLog(response.data);
          setNotesLogVisible(true);
        }
        else{
          msgs.current.show({severity: 'error', summary: '', detail: 'Error fetching notes log for the project.'});
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching notes log for the project:', error);
        setLoading(false);
        if (handleAccessError(error)) {
          return;
        }
        msgs.current.show({severity: 'error', summary: '', detail: 'Error fetching notes log for the project.'});
      }
    }
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('projectsFilters', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

    const clear = () => {
  
    toastBC.current.clear();
  };

  const updateProject = async (project) => {
    try{
      clear(true);
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      console.log(project);
      const response = await axios.put(global.config.url + `/projects/` + project.id, {
        "orderNumber": project.orderNumber,
        "logoProvided": project.logoProvided,
        "addedToAjax": project.addedToAjax,
        "kitSentDate": project.kitSentDate,
        "kitSentPlace": project.kitSentPlace,
        "installer": project.installer,
        "notes": project.notes,
        "addedToSocial": project.addedToSocial,
      } , axiosConfig);
      console.log(response);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: `Project successfully updated.`});
        return { ok: true, data: response.data };
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error updating the project.'});
        return { ok: false, data: null };
      }
    } catch (error) {
      console.error('Error updating project:', error);
      if (handleAccessError(error)) {
        return { ok: false, data: null };
      }
      return { ok: false, data: null };
    }
  };

  const confirmProjectSave = (draft) => {
    toastBC.current.show({
      severity: 'info',
      sticky: true,
      className: 'border-none',
      content: (
        <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
          <div className="text-center">
            <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
            <div className="font-bold text-xl my-3">Save changes?</div>
          </div>
          <div className="flex align-items-center">
            <Button
              onClick={() => saveProjectDraft(draft)}
              type="button"
              label="Yes"
              className="p-button-success w-6rem"
              disabled={editProjectSaving}
            />
            <Button
              onClick={() => clear(false)}
              type="button"
              label="No"
              className="p-button-warning w-6rem mx-4"
              disabled={editProjectSaving}
            />
          </div>
        </div>
      ),
    });
  };

  const openEditProjectDialog = (project) => {
    const selected = project || rowSelectionModel;
    if (!selected || !selected.id) {
      msgs.current.show({ severity: 'error', summary: '', detail: 'Please select a project to edit.' });
      return;
    }

    setEditProjectDraft({ ...selected });
    setEditProjectVisible(true);
  };

  const closeEditProjectDialog = () => {
    setEditProjectVisible(false);
    setEditProjectDraft(null);
  };

  const patchEditProjectDraft = (patch) => {
    setEditProjectDraft((prev) => {
      if (!prev) return prev;
      return { ...prev, ...patch };
    });
  };

  const saveProjectDraft = async (draft) => {
    if (!draft || !draft.id) return;
    setEditProjectSaving(true);
    const scrollTop = getTableScrollTop();

    const result = await updateProject(draft);
    if (result.ok) {
      const apiData = result.data;
      const updatedProject = apiData && typeof apiData === 'object' ? { ...draft, ...apiData } : { ...draft };
      setProjects((prev) => prev.map((p) => (p.id === updatedProject.id ? { ...p, ...updatedProject } : p)));
      setProjectsShow((prev) => prev.map((p) => (p.id === updatedProject.id ? { ...p, ...updatedProject } : p)));
      setRowSelectionModel((prev) => (prev && prev.id === updatedProject.id ? { ...prev, ...updatedProject } : prev));
      closeEditProjectDialog();
      restoreTableScrollTop(scrollTop);
    }

    setEditProjectSaving(false);
    clear(false);
  };

  const selectRow = (e) => {
    console.log(e);
    setRowSelectionModel(e);
    setShowOptions(true);
    // op.current.toggle(e);
    console.log(e.status.trim());
    if(e.status.trim() === "New"){
      console.log("new project");
      setNewProject(true);
      setArchivedProject(false);
      setHoldedProject(false);
    }
    else if(e.status.trim() === "Archived"){
      setNewProject(false);
      setArchivedProject(true);
      setHoldedProject(false);
    }
    else if(e.status.trim() === "On Hold"){
      setNewProject(false);
      setArchivedProject(false);
      setHoldedProject(true);
    }
  };
  const textEditor = (options) => {
    return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
  };

    const textAreaEditor = (options) => {
    return <InputTextarea value={options.value} onChange={(e) => options.editorCallback(e.target.value)} cols={30} rows={5} />;
  };

  const archiveProject = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a project to archive it.'});
    }
    else
    {
      try{
        clear(true);
        const token = localStorage.getItem('token');
        var axiosConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        };
        const response = await axios.put(global.config.url + `/projects/archive/` + rowSelectionModel.id, {} , axiosConfig);
        console.log(response);
        if(response.status === 200){
          msgs.current.show({severity: 'success', summary: '', detail: `Project successfully archived.`});
          getProjects();
        }
        else{
          msgs.current.show({severity: 'error', summary: '', detail: 'Error archiving the project.'});
        }
      } catch (error) {
        console.error('Error archiving project:', error);
        if (handleAccessError(error)) {
          return;
        }
        msgs.current.show({severity: 'error', summary: '', detail: 'Error archiving the project.'});
      }
    }
  };

  const holdProject = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a project to put it on hold.'});
    }
    else
    {
      try{
        clear(true);
        const token = localStorage.getItem('token');
        var axiosConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        };
        const response = await axios.put(global.config.url + `/projects/hold/` + rowSelectionModel.id, {} , axiosConfig);
        console.log(response);
        if(response.status === 200){
          msgs.current.show({severity: 'success', summary: '', detail: `Project successfully put on hold.`});
          getProjects();
        }
        else{
          msgs.current.show({severity: 'error', summary: '', detail: 'Error putting the project on hold.'});
        }
      } catch (error) {
        console.error('Error putting project on hold:', error);
        if (handleAccessError(error)) {
          return;
        }
        msgs.current.show({severity: 'error', summary: '', detail: 'Error putting the project on hold.'});
      }
    }
  };
  const projectBackToNew = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a project to put it back to New status.'});
    }
    else
    {
      try{
        clear(true);
        const token = localStorage.getItem('token');
        var axiosConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        };
        const response = await axios.put(global.config.url + `/projects/backtonew/` + rowSelectionModel.id, {} , axiosConfig);
        console.log(response);
        if(response.status === 200){
          msgs.current.show({severity: 'success', summary: '', detail: `Project successfully put back to New status.`});
          getProjects();
        }
        else{
          msgs.current.show({severity: 'error', summary: '', detail: 'Error putting the project back to New status.'});
        }
      } catch (error) {
        console.error('Error putting project back to New status:', error);
        if (handleAccessError(error)) {
          return;
        }
        msgs.current.show({severity: 'error', summary: '', detail: 'Error putting the project back to New status.'});
      }
    }
  };
  const startContent = (
    <React.Fragment>
      <div>
        <Button onClick={() => { setShowOptions(false); openEditProjectDialog(); }} label="Edit Project" icon="pi pi-pencil" className="p-button-success ml-5" tooltip="Edit this project" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => archiveProject()} visible={!archivedProject} label="Archive Project" icon="pi pi-inbox" className="p-button-warning ml-5" tooltip="Archive this project" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => holdProject()} visible={!holdedProject} label="Hold Project" icon="pi pi-pause" className="p-button-info ml-5" tooltip="Put this project on hold" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => projectBackToNew()} visible={!newProject} label="Back to New" icon="pi pi-replay" className="p-button-help ml-5 mt-5" tooltip="Put this project back to New status" tooltipOptions={{position:"bottom"}}/>
      </div>
      <Button onClick={() => getNotesLog()} label="Notes Log" icon="pi pi-book" className="p-button-secondary mx-5 mt-5" tooltip="Show notes log for this project" tooltipOptions={{position:"bottom"}}/>
      <Button onClick={() => copyProjectsToClipboard()} label="Copy Details" icon="pi pi-copy" className="p-button-primary mt-5" tooltip="Copy project details to clipboard" tooltipOptions={{position:"bottom"}}/>
      <Button onClick={() => getOrderDetailsbyOrderId()} label="Order Details" icon="pi pi-info-circle" className="p-button-danger mx-5 mt-5" tooltip="Show order details for this project" tooltipOptions={{position:"bottom"}}/>
        {/* <Button onClick={() => getEvents()} label="Get Events" icon="pi pi-file" className="p-button-warning mx-5" tooltip="Get events for this access point" tooltipOptions={{position:"bottom"}}/> */}
        {/* <Button onClick={() => getExtraInfo()} label="Extra Info" icon="pi pi-info-circle" className="p-button-info" tooltip="Get extra information for this access point" tooltipOptions={{position:"bottom"}}/> */}
    </React.Fragment>
);

const copyProjectsToClipboard = () => {
  
  if(rowSelectionModel === undefined || rowSelectionModel.id === 0){
    msgs.current.show({severity: 'error', summary: '', detail: 'Please select a project to copy its details.'});
  }
  else
  {
    let ap = projects.find(x => x.id === rowSelectionModel.id);
    //copy in spreadsheet format
    let copyText = `${ap.orderStatus}\t${ap.lMS}\t${ap.appProvider}\t${ap.hubRelay}\t${ap.addedToAjax}\t${ap.ajaxToPortal}\t${ap.kitSentDate}\t${ap.kitSentPlace}\t${ap.installer}\t${ap.notes}\t${ap.status}`;
    navigator.clipboard.writeText(copyText);
    msgs.current.show({severity: 'success', summary: '', detail: 'Project details copied to clipboard.'});
  }
};
const filterContent = (
    <span className="p-input-icon-left mb-3 ml-3">
      <i className="pi pi-search" />
      <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter by order status, app provider, LMS and installer" tooltip="Start typing an order status, app provider, LMS or installer" tooltipOptions={{position: "bottom"}}  />
    </span>
);

const clearFilter = () => {
  
  let _filters = { ...filters };
  _filters['global'].value = null;
  setFilters(_filters);
  setGlobalFilterValue('');
  localStorage.removeItem('projectsFilters');
};

const optionsTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button
          link
          icon="pi pi-pencil"
          onClick={() => {
            setRowSelectionModel(rowData);
            openEditProjectDialog(rowData);
          }}
          tooltip="Edit project"
          tooltipOptions={{ position: 'bottom' }}
        />
        <Button
          link
          icon="pi pi-ellipsis-v"
          onClick={() => {
            setRowSelectionModel(rowData);
            setShowOptions(true);
          }}
          tooltip="Project actions"
          tooltipOptions={{ position: 'bottom' }}
        />
      </div>
    );
  };

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

    const goBack = () => {
  
      localStorage.removeItem('projectsFilters');
      navigate(-1);
    }

    const onOrderDetailsEditComplete = (e) => {
  let result = window.confirm('Are you sure you want to save the changes?');
  if(!result){
    return;
  }
  let { newData, index } = e;
  let orderdetails = [...fullOrderDetails];
  orderdetails[index] = newData;
  setFullOrderDetails(orderdetails);
  setLoadingOrders(true);
  let token = localStorage.getItem('token');
  let axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };
//   for (const key in newData) {
//   if (newData[key] === null) {
//     newData[key] = ""; // Replace null with desired value
//   }
// }
  const response = axios.put(global.config.url + '/orders/updateorderdetails', newData, axiosConfig);
  response.then((res) => {
    if(res.status === 204){
      editOrderDetailsmsg.current.show({severity: 'success', summary: '', detail: `Order details for order ${newData.orderNumber} successfully updated.`});
      getOrderDetailsbyOrderId();
    }
    else{
      editOrderDetailsmsg.current.show({severity: 'error', summary: '', detail: `Error updating order details, please try again.`});
    }
  }).catch((error) => {
    console.error('Error updating order details:', error);
    if (handleAccessError(error)) {
      setLoadingOrders(false);
    }
    else if(error.response && error.response.status === 400){
      editOrderDetailsmsg.current.show({severity: 'error', summary: '', detail: 'Error updating order details, please try again.'});
    }
    else{
      editOrderDetailsmsg.current.show({severity: 'error', summary: '', detail: 'Error updating order details, please try again.'});
    }
  });
};

const getOrderDetailsbyOrderId = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.orderId === 0){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a project to see its order details.'});
      return;
    }
    try {
      msgs.current.show({severity: 'info', summary: '', detail: 'Loading order details, please wait...'});
      setLoadingOrderDetails(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(global.config.url + `/orders/orderdetails/${rowSelectionModel.orderId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setFullOrderDetails(response.data);
      console.log(response.data);
      setOrderDetailsVisible(true);
    } catch (error) {
      if (handleAccessError(error)) {
        return;
      }
      msgs.current.show({severity: 'error', summary: '', detail: 'Error loading order details.'});
    } finally {
      setLoadingOrderDetails(false);
    }
  };

  const orderDetailsFilterChange = (e) => {
  const value = e.target.value;
  let _filters = { ...orderDetailsFilters };
  _filters['global'].value = value;
  localStorage.setItem('customers-orderDetailsFilter', JSON.stringify(_filters))
  setOrderDetailsFilters(_filters);
  setOrderDetailsFilterValue(value);
};

  if (accessIssue) {
    return <AccessState {...accessIssue} />;
  }

  return (
      <Container fluid className ="justify-content-md-center mt-5">
        <div className="flex justify-content-center mt-3">
          <Container className="flex align-content-center flex-wrap">
            
            <Button link icon="pi pi-arrow-left" onClick={() => goBack()} className='flex mb-3'/> 
            <h4 className='flex mt-2 mb-3 ml-3'>Projects</h4> 
            <div>
              {filterContent}
              <Button icon="pi pi-times" className="p-button-text mb-3" onClick={() => clearFilter()} tooltip="Clear filter" tooltipOptions={{position: "bottom"}}/>
              <Button icon="pi pi-refresh" className="p-button-text mb-3" onClick={() => getProjects("Refresh")} disabled={loading} tooltip="Refresh projects" tooltipOptions={{position: "bottom"}}/>
              <Button type="button" icon="pi pi-inbox" rounded className="p-button-warning mb-3 mx-3" onClick={() => getProjects("Archived")} disabled={loading} tooltip="Show archived projects" tooltipOptions={{position: "bottom"}}/>
              <Button type="button" icon="pi pi-pause" rounded className="p-button-info mb-3" onClick={() => getProjects("On Hold")} disabled={loading} tooltip="Show projects on hold" tooltipOptions={{position: "bottom"}}/>
              <Button type="button" rounded label='All' className="p-button-help mb-3 mx-3" onClick={() => getProjects("All")} disabled={loading} tooltip="Show all projects" tooltipOptions={{position: "bottom"}}/>
            </div>

          </Container>
          </div>
        <Messages ref={msgs} />
        <Toast ref={toastBC} position="top-center" />
        {loading && progressbar}
        <div className='justify-content-md-center mt-3'>
          <Dialog visible={showOptions} onHide={() => setShowOptions(false)} style={{ width: '100%' }}>
            {startContent}
          </Dialog>

          <Dialog
            visible={editProjectVisible}
            onHide={closeEditProjectDialog}
            header="Edit Project"
            modal
            style={{ width: '50rem', maxWidth: '95vw' }}
          >
            {!editProjectDraft ? null : (
              <div className="p-fluid">
                <div className="field">
                  <label>Customer</label>
                  <InputText value={editProjectDraft.customer || ''} disabled />
                </div>
                <div className="field">
                  <label>Locations</label>
                  <InputText value={editProjectDraft.locations || ''} disabled />
                </div>
                <div className="field">
                  <label>Installer</label>
                  <InputText
                    value={editProjectDraft.installer || ''}
                    onChange={(e) => patchEditProjectDraft({ installer: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Added To Ajax</label>
                  <InputText
                    value={editProjectDraft.addedToAjax || ''}
                    onChange={(e) => patchEditProjectDraft({ addedToAjax: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Kit Sent Date</label>
                  <InputText
                    value={editProjectDraft.kitSentDate || ''}
                    onChange={(e) => patchEditProjectDraft({ kitSentDate: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Kit Sent Place</label>
                  <InputText
                    value={editProjectDraft.kitSentPlace || ''}
                    onChange={(e) => patchEditProjectDraft({ kitSentPlace: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Added To Social</label>
                  <InputText
                    value={editProjectDraft.addedToSocial || ''}
                    onChange={(e) => patchEditProjectDraft({ addedToSocial: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Notes</label>
                  <InputTextarea
                    value={editProjectDraft.notes || ''}
                    onChange={(e) => patchEditProjectDraft({ notes: e.target.value })}
                    rows={6}
                  />
                </div>
                <div className="flex justify-content-end mt-4">
                  <Button
                    label="Cancel"
                    className="p-button-text"
                    onClick={closeEditProjectDialog}
                    disabled={editProjectSaving}
                  />
                  <Button
                    label="Save"
                    icon="pi pi-check"
                    className="p-button-success ml-3"
                    onClick={() => confirmProjectSave(editProjectDraft)}
                    loading={editProjectSaving}
                  />
                </div>
              </div>
            )}
          </Dialog>

          <DataTable
            value={projects}
            selectionMode={'single'}
            selection={rowSelectionModel}
            onSelectionChange={(e) => selectRow(e.value)}
            dataKey="id"
            style={{ width: '100%' }}
            filters={filters}
            ref={dt}
            globalFilterFields={['orderStatus', 'lMS', 'appProvider', 'installer', 'customer', 'locations']}
            emptyMessage={loading ? "Loading projects..." : "No projects found."}
            scrollable
            scrollHeight="80vh"
            stripedRows
            resizableColumns
            columnResizeMode="fit"
          >
            <Column field="options" header="" body={optionsTemplate} frozen></Column>
            <Column field="customer" header="Customer" sortable frozen></Column>
            <Column field="locations" header="Locations" sortable style={{ whiteSpace: 'pre' }} frozen></Column>
            <Column field="notes" header="Notes" sortable style={{ width: "500px", whiteSpace: 'pre' }}></Column>
            <Column field="orderStatus" header="Order Status" sortable></Column>
            <Column field="orderStatusLastChange" header="Order Status Change" sortable></Column>
            <Column field="lms" header="LMS" sortable></Column>
            <Column field="appProvider" header="App Provider" sortable></Column>
            <Column field="installer" header="Installer" sortable></Column>
            <Column field="logoProvided" header="Logo Provided" sortable></Column>
            <Column field="hubRelay" header="Hub & Relay" sortable></Column>
            <Column field="addedToAjax" header="Added To Ajax" sortable></Column>
            <Column field="ajaxToPortal" header="Ajax To Portal" sortable></Column>
            <Column field="kitSentDate" header="Kit Sent Date"></Column>
            <Column field="kitSentPlace" header="Kit Sent Place" sortable></Column>
            <Column field="addedToSocial" header="Added To Social" sortable></Column>
            <Column field="status" header="Status" sortable></Column>
          </DataTable>
        </div>
           <div className="card flex justify-content-center" >
          <Dialog className='justify-content-center' visible={orderDetailsVisible} onHide={() => setOrderDetailsVisible(false)} style={{ minWidth: '5rem' }} >    
            {/* <div className="card">
            <Toolbar className='' start={} />
            </div> */}
            <Container className="flex mx-5">

              <React.Fragment>
              <h4 className='mt-3'>Orders</h4>
                <span className="p-input-icon-left mx-3">
                  <i className="pi pi-search" />
                  <InputText value={orderDetailsFilterValue} onChange={orderDetailsFilterChange} placeholder="Filter by location name, gate name, size or colour" tooltip="Start typing a location name, gate name, size or colour" tooltipOptions={{position: "bottom"}}  />
                </span>     
                {/* <Button icon="pi pi-qrcode" className="p-button-info" rounded onClick={() => getAccessPointsByOrder()} tooltip="Get access points per order" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-file-export" className="p-button-warning ml-3" rounded onClick={() => sendOrderCsvbyOrder()} tooltip="Download order report CSV" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-check" className="p-button-success ml-3" rounded onClick={() => markOrderAsComplete()} tooltip="Mark order as completed" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-envelope" className="p-button-secondary ml-3" rounded onClick={() => sendShippingNotebyOrder()} tooltip="Send shipping note" tooltipOptions={{position: "bottom"}} /> */}
              </React.Fragment> 
            </Container>
          <div className='justify-content-md-center mt-5 mb-5 mx-5' >
              <Messages ref={editOrderDetailsmsg} />
              <DataTable value={fullOrderDetails} dataKey="id" showGridlines filters={orderDetailsFilters} 
              globalFilterFields={['locationName', 'gateName', 'clientName', 'type', 'scanType', 'size', 'colour']} selectionMode='single' 
              emptyMessage={loadingOrders ? "Loading order details..." : "No order details found."} ref={dt} tableStyle={{ minWidth: '5rem' }}
              scrollable scrollHeight="60vh" style={{ maxWidth: '90rem' }}
              editMode='row' onRowEditComplete={onOrderDetailsEditComplete}>
                <Column field="orderNumber" header="Order Number" />
                <Column field="orderType" header="Order Type" sortable/>
                <Column field="customerName" header="Customer" sortable/>
                <Column field="locationName" header="Location" sortable/>
                <Column field="gateName" header="Gate" sortable/>
                <Column field="clientName" header="Client Name" sortable/>
                <Column field ="type" header="Type" sortable/>
                <Column field ="scanType" header="Scan Type" sortable/>
                <Column field ="lms" header="LMS" />
                <Column field ="controllerType" header="Controller Type" sortable editor={(options) => textEditor(options)}/>
                <Column field ="hubNumber" header="Hub Number" editor={(options) => textEditor(options)}/>
                <Column field ="relayNumber" header="Relay Number" editor={(options) => textEditor(options)}/>
                <Column field ="buttonNumber" header="Button Number" editor={(options) => textEditor(options)}/>
                <Column field ="size" header="Size" sortable editor={(options) => textEditor(options)}/>
                <Column field ="colour" header="Colour" sortable editor={(options) => textEditor(options)}/>
                <Column field ="quantity" header="Quantity" editor={(options) => textEditor(options)}/>
                <Column field="scanner" header="Scanner" sortable editor={(options) => textEditor(options)}/>
                <Column field="singleCable" header="Single Cable" editor={(options) => textEditor(options)}/>
                <Column field="doubleCable" header="Double Cable" editor={(options) => textEditor(options)}/>
                <Column field="accessPointSetup" header="AccessPoint Setup" />
                <Column field="deepLinkEntered" header="Deep Link Entered" />
                <Column field="clientInstalled" header="Client Installed"/>
                <Column field="ordered" header="Ordered"/>
                <Column field="boostShipped" header="Boost Shipped"/>
                <Column field="orderSent" header="Order Sent"/>
                <Column field="live" header="Live"/>
                <Column field="status" header="Status"/>
                <Column field="comments" header="Comments" editor={(options) => textEditor(options)}/>
                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
              </DataTable>
          </div>
          </Dialog>
        </div>
          {/* <div>
            <p className='mt-3'>Type: It is either Tile, AccessPod, TilePodMini, TilePodMini with Backboard or TilePod</p>
            <p className='mt-3'>ScanType: It is either Access, Member Information or Check-in</p>
          </div> */}
          <div className='mb-5'>
            <Dialog visible={notesLogVisible} onHide={() => setNotesLogVisible(false)} style={{ minWidth: '20rem' }} header="Notes log" modal className="p-fluid">
              <DataTable value={notesLog} tableStyle={{ minWidth: '5rem' }}
              emptyMessage={loading ? "Loading notes log..." :"No notes found for this project."} 
              scrollable scrollHeight="50vh">
                  <Column field="created" header="Date" body={(rowData) => new Date(rowData.created).toLocaleString()} sortable></Column>
                  <Column field="note" header="Note" sortable></Column>
              </DataTable>
            </Dialog>
          </div>

                  <OverlayPanel ref={op}>
            {startContent}
          </OverlayPanel>
        <ScrollTop />
      </Container>
    
  );
};

export default Projects;
